<template>
  <!-- start feature.extra section  -->
  <div>
    <button class="my-3 btn btn-info mr-3" @click="showModal=true" data-toggle="modal"
            :data-target="`#feature-extra-${productFeature.id}`">
      بیشتر
    </button>

    <div class="modal fade" v-if="showModal" :id="`feature-extra-${productFeature.id}`" tabindex="-1"
         aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div dir="rtl" class="text-right">
              <form @submit.prevent="submitFeatureExtraChanges">
                <div class="row align-items-center justify-content-center">

                  <div class="col-lg-4">

                    <div class="form-group">
                      <label for="feature-extra-category">
                        دسته بندی
                        <i class="bi bi-plus-circle-fill"
                           data-toggle="modal" :data-target="`#create-feature-category-${productFeature.id}`"
                        />
                      </label>
                      <select v-model="featureExtraForm.category" class="form-control custom-select">
                        <option v-for="category in featureCategories" :value="category.value">{{
                            category.text
                          }}
                        </option>
                      </select>
                    </div>

                    <form-errors-manager :validation="v$.featureExtraForm.category"/>
                  </div>


                  <div class="col-lg-4">
                    <div class="form-group">
                      <label for="feature-extra-item-order">ترتیب ویژگی</label>
                      <input v-model="featureExtraForm.item_order" type="text" class="form-control"
                             id="feature-extra-item-order">
                    </div>
                    <form-errors-manager :validation="v$.featureExtraForm.item_order"/>
                  </div>


                  <button class="btn btn-primary" type="submit">ثبت</button>

                </div>

              </form>


              <div class="modal fade" :id="`create-feature-category-${productFeature.id}`" tabindex="-1"
                   aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div dir="rtl" class="text-right">
                        <form @submit.prevent="createNewFeatureCategory">


                          <div class="col-lg-12 mb-3 text-right">
                            <label>نام دسته بندی</label>

                            <input v-model="form.featureCategoryName" type="text" class="form-control">

                            <form-errors-manager :validation="v$.form.featureCategoryName"/>
                          </div>


                          <button class="btn btn-primary" type="submit">ثبت</button>


                        </form>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
/*
* use showModal on data section to refresh component
* this refresh will effect the dom and make all checkbox have same value
*
* */
import {numeric, required} from "@vuelidate/validators";
import {useVuelidate} from '@vuelidate/core'
import FormErrorsManager from "../../../../../validator/FormErrorsManager.vue";
import $ from 'jquery'

export default {
  name: "FeatureItemExtra",
  components: {FormErrorsManager},
  props: {
    productFeature: {},
    product: {}
  },
  setup: () => ({v$: useVuelidate()}),
  data() {
    return {
      $,
      form: {
        featureCategoryName: '',
      },
      featureExtraForm: {
        item_order: '',
        category: '',
      },
      showModal: false
    }
  },
  validations() {
    return {
      form: {
        featureCategoryName: {required},
      },
      featureExtraForm: {
        item_order: {required, numeric},
        category: {required},
      }
    }

  },
  computed: {
    featureCategories() {
      let categories = []


      this.product.features.forEach((item) => {
        let itemCategory = item.extra.category
        categories.push({text: itemCategory, value: itemCategory})
      })

      let uniqueCategories = categories.filter((obj, index, self) =>
          index === self.findIndex((t) => t.text === obj.text && t.value === obj.value)
      );

      return uniqueCategories

    },
  },
  methods: {
    async invalid() {
      const result = await this.v$.form.$validate()
      if (!result) return false
      return true
    },
    async invalidFeatureExtra() {

      const result = await this.v$.featureExtraForm.$validate()
      if (!result) return false
      return true

    },
    async createNewFeatureCategory() {
      if (await this.invalid()) {
        this.productFeature.extra.category = this.form.featureCategoryName
        this.productFeature.extra.item_order = 1
        this.showModal = false
        $(`#feature-extra-${this.productFeature.id}`).modal('hide')
        $(`#create-feature-category-${this.productFeature.id}`).modal('hide')
      }
    },
    async submitFeatureExtraChanges() {
      if (await this.invalidFeatureExtra()) {
        if (this.productFeature.feature.type == 'checkbox') {

          // find all checkbox in same group and update them
          this.product.features.forEach(item => {
            if (item.extra.group == this.productFeature.extra.group) {
              item.extra.category = this.featureExtraForm.category
              item.extra.item_order = parseInt(this.featureExtraForm.item_order)
            }
          })

        }
        this.productFeature.extra.category = this.featureExtraForm.category
        this.productFeature.extra.item_order = parseInt(this.featureExtraForm.item_order)
        this.showModal = false
        $(`#feature-extra-${this.productFeature.id}`).modal('hide')
        this.initComponent()
        this.$forceUpdate()
      }
    },
    initComponent() {
      let productFeatureClone = this.productFeature.extra
      this.featureExtraForm.category = productFeatureClone.category
      this.featureExtraForm.item_order = productFeatureClone.item_order
    },

  },
  mounted() {
    this.initComponent()


  }
}
</script>

<style scoped>

</style>